export const VALIDATION_MESSAGES = {
    required: 'Это поле обязательно для заполнения',
    name: 'Введите корректное имя (только буквы, 2–50 символов)',
    phone: 'Введите корректный номер телефона (9 цифр после +998)',
    email: 'Введите корректный email',
};

// Имя/Фамилия — только буквы (кириллица/латиница), пробелы, дефис, апостроф
export function validateName(value, required = true) {
    const trimmed = (value || '').trim();
    if (!trimmed) {
        return required ? VALIDATION_MESSAGES.required : '';
    }
    if (!/^[A-Za-zА-Яа-яЁёʼ'\- ]{2,50}$/.test(trimmed)) {
        return VALIDATION_MESSAGES.name;
    }
    return '';
}

// Телефон — принимает и "+998 90 123 45 67", и "901234567" (локальная часть)
// Валиден, если после очистки от нецифровых символов остаётся ровно 9 цифр локальной части
export function validatePhone(value) {
    const trimmed = (value || '').trim();
    if (!trimmed) {
        return VALIDATION_MESSAGES.required;
    }
    const digits = trimmed.replace(/\D/g, '');
    const localDigits = digits.startsWith('998') ? digits.slice(3) : digits;
    if (localDigits.length !== 9) {
        return VALIDATION_MESSAGES.phone;
    }
    return '';
}

// Email — необязательное поле, но если введено, должно быть корректным
export function validateEmail(value) {
    const trimmed = (value || '').trim();
    if (!trimmed) return '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
        return VALIDATION_MESSAGES.email;
    }
    return '';
}

// Приводит телефон к единому формату +998XXXXXXXXX перед отправкой на бэкенд
export function normalizePhoneUZ(value) {
    const digits = (value || '').replace(/\D/g, '');
    const localDigits = digits.startsWith('998') ? digits.slice(3) : digits;
    return `+998${localDigits}`;
}

// Общая функция для проверки блока "Имя/Фамилия/Телефон/Email" сразу
export function validateContactFields({ firstName, lastName, phone, email }) {
    return {
        firstName: validateName(firstName),
        lastName: validateName(lastName),
        phone: validatePhone(phone),
        email: validateEmail(email),
    };
}

export function hasErrors(errorsObj) {
    return Object.values(errorsObj).some((msg) => !!msg);
}